import React from 'react';
import {
  Drawer,
  drawerStyles,
} from '@/components/system/Layout/LayoutWebCore/WebCoreAppBar/AppDrawer/styles';
import Scrollbar from '@/components/ui/Scrollbar';
import WoWSpaceAppMenus from '@/components/system/Layout/LayoutWebCore/WebCoreAppMenus/WoWSpaceMenus';
import MoonLogo from '@/components/biz/MoonLogo';
import { Box, IconButton } from '@mui/material';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import MenuIcon from '@mui/icons-material/Menu';

interface WoWSpaceDrawerProps {
  appSidebarOpen: boolean;
  isMobile: boolean;
  toggleDrawerOpen: () => void;
}

export const WoWSpaceDrawer: React.FC<WoWSpaceDrawerProps> = ({
  appSidebarOpen,
  isMobile,
  toggleDrawerOpen,
}) => {
  return (
    <Drawer variant="permanent" open={appSidebarOpen} sx={drawerStyles}>
      <Box
        sx={{
          mt: -1,
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          position: 'relative',
        }}
      >
        <Box
          sx={{
            height: 46,
            pointerEvents: appSidebarOpen ? 'auto' : 'none',
          }}
        >
          <MoonLogo
            variant="header"
            width={128}
            height={46}
            sx={{
              marginLeft: 1,
              opacity: appSidebarOpen ? 1 : 0,
              transition: '.2s ease-in-out',
            }}
          />
        </Box>

        <IconButton
          onClick={toggleDrawerOpen}
          size="small"
          sx={{
            position: 'absolute',
            top: 10,
            right: appSidebarOpen ? 0 : 6,
            width: 30,
            height: 30,
            borderRadius: 1,
            color: 'rgba(255,255,255,0.38)',
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            transition: '.1s',
            '&:hover': {
              color: 'rgba(255,255,255,0.8)',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
          }}
        >
          {appSidebarOpen ? (
            <MenuOpenIcon fontSize="small" />
          ) : (
            <MenuOpenIcon fontSize="small" sx={{ transform: 'scaleX(-1)' }} />
          )}
        </IconButton>
      </Box>

      <Scrollbar autoHide>
        {/* WoW Space 专用菜单 */}
        <WoWSpaceAppMenus open={appSidebarOpen} />
      </Scrollbar>
    </Drawer>
  );
};

export default WoWSpaceDrawer;
